/* nc-cart-fixes.js — runtime corrections for the cart drawer.

   Two problems, both only reproducible on a real iPhone:

   1. THUMBNAILS NEVER LOADED. Horizon renders cart line images with
      loading="lazy" and a responsive `sizes` attribute. The drawer lives in a
      <dialog> with no layout box until it opens, so on iOS Safari the fetch is
      never scheduled, and `sizes` resolves against a zero-width box. Result: an
      empty grey tile. We force eager loading and pin `sizes` to the real
      rendered width so the browser picks a sensible candidate.

   2. THE UPSELL SHELF WAS STRANDED AT THE BOTTOM. .cart-drawer__items is a
      flex-growing scroll region and something inside Horizon's cart markup
      stretches to fill it, pushing "People also bought" to the bottom of the
      scroll area and under the sticky summary. Rather than guess which element
      that is — the class names differ between Horizon versions — we walk up
      from the last line item to the scroll region and collapse every ancestor
      to its natural height. The shelf then sits directly beneath the last line
      and moves down as items are added, with the empty space falling below it.

   Everything re-runs on cart:update, because the drawer re-renders its
   contents (fresh lazy images, fresh stretched wrappers) on every change. */
(function () {
  if (window.__ncCartFixes) return;
  window.__ncCartFixes = true;

  var DIALOG = '.cart-drawer__dialog';

  function fixImages() {
    var imgs = document.querySelectorAll(DIALOG + ' .cart-items__media-container img, ' + DIALOG + ' .cart-items__media img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.loading = 'eager';
      img.decoding = 'sync';

      /* `sizes` was resolved while the dialog had no layout box. Pin it to the
         box we actually render (6.5rem = 104px, 2x for retina). */
      if (img.getAttribute('srcset')) {
        if (img.getAttribute('sizes') !== '208px') img.setAttribute('sizes', '208px');
      }

      /* If the fetch was skipped entirely, re-assigning src restarts it. */
      if (!img.complete || img.naturalWidth === 0) {
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', src);
      }
    }
  }

  function unstretch() {
    var region = document.querySelector(DIALOG + ' .cart-drawer__items');
    if (!region) return;

    var rows = region.querySelectorAll('.cart-items__table-row');
    var last = null;
    for (var i = rows.length - 1; i >= 0; i--) {
      if (rows[i].querySelector('.cart-items__title')) { last = rows[i]; break; }
    }
    if (!last) return;

    /* Collapse every ancestor between the last line item and the scroll
       region. One of them is stretching to the region's full height; this
       flattens all of them without needing to know which. */
    var node = last.parentElement;
    while (node && node !== region) {
      node.style.height = 'auto';
      node.style.minHeight = '0';
      node.style.flexGrow = '0';
      node.style.flexBasis = 'auto';
      node = node.parentElement;
    }

    /* Keep the shelf immediately after the cart block inside the scroll area. */
    var up = region.querySelector('.nc-up');
    if (!up) return;
    var block = last;
    while (block && block.parentElement !== region) block = block.parentElement;
    if (block && block.nextElementSibling !== up) {
      region.insertBefore(up, block.nextSibling);
    }
  }

  function run() {
    fixImages();
    unstretch();
  }

  function runSoon() {
    run();
    setTimeout(run, 200);
    setTimeout(run, 700);
    setTimeout(run, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSoon);
  } else {
    runSoon();
  }

  document.addEventListener('cart:update', runSoon);

  var dialog = document.querySelector(DIALOG);
  if (dialog && window.MutationObserver) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; run(); });
    }).observe(dialog, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[class*="cart"], [href*="/cart"]')) runSoon();
  }, true);
})();
